/* PERROWALL PDP (v2 maquette) — galerie, sélecteur d'offres -> formulaire panier Shopify réel, sticky ATC, livraison. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var I = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v8H3z"/><path d="M14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>'
  };
  var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  function fmt(cents) {
    var n = cents / 100;
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: CUR, minimumFractionDigits: (n % 1 === 0 ? 0 : 2) }).format(n); }
    catch (e) { return (n % 1 === 0 ? n : n.toFixed(2).replace('.', ',')) + ' €'; }
  }

  function reveal() {
    var els = $$('.pw-store .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (ents) { ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }); }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function gallery() {
    var main = $('#galMain'); if (!main) return;
    var img = $('#galImg');
    var thumbs = $$('.gallery__thumbs button');
    if (thumbs.length < 2) return;
    var counter = $('#galCur');
    var n = thumbs.length;
    var cur = thumbs.findIndex(function (t) { return t.classList.contains('active'); });
    if (cur < 0) cur = 0;

    function go(i) {
      cur = ((i % n) + n) % n; // navigation circulaire
      var b = thumbs[cur];
      thumbs.forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
      if (counter) counter.textContent = cur + 1;
      if (b.scrollIntoView) b.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      var full = b.dataset.full;
      if (full && img && img.getAttribute('src') !== full) {
        img.style.opacity = '0';
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          img.removeAttribute('srcset');
          img.src = full;
          requestAnimationFrame(function () { img.style.opacity = '1'; });
        };
        pre.src = full;
      }
    }

    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });

    var prev = $('#galPrev'), next = $('#galNext');
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); go(cur - 1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); go(cur + 1); });

    // Clic sur l'image -> suivant (hors flèches)
    main.addEventListener('click', function (e) { if (e.target.closest('.gallery__nav')) return; go(cur + 1); });

    // Clavier (l'image est focusable)
    main.setAttribute('tabindex', '0');
    main.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });

    // Swipe tactile sur l'image principale -> photo précédente / suivante
    var x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      go(dx < 0 ? cur + 1 : cur - 1);
    }, { passive: true });
  }

  function offers() {
    var list = $('#bundles'); if (!list) return;
    var vid = $('#pwVariantId');
    var now = $('#bbNow'), was = $('#bbWas'), saveEl = $('#bbSave');
    var stNow = $('#atcNow'), stSave = $('#atcSave');
    function apply(el) {
      $$('.bundle', list).forEach(function (x) { x.classList.remove('active'); x.setAttribute('aria-checked', 'false'); });
      el.classList.add('active');
      el.setAttribute('aria-checked', 'true');
      if (vid) vid.value = el.dataset.vid;
      var p = Number(el.dataset.price), w = Number(el.dataset.compare) || 0;
      if (now) now.textContent = fmt(p);
      if (was) { was.textContent = w > p ? fmt(w) : ''; was.style.display = w > p ? '' : 'none'; }
      if (saveEl) { var pct = w > p ? Math.round((1 - p / w) * 100) : 0; saveEl.textContent = pct ? '-' + pct + '%' : ''; saveEl.style.display = pct ? '' : 'none'; }
      if (stNow) stNow.textContent = fmt(p);
      if (stSave) stSave.textContent = w > p ? 'économise ' + fmt(w - p) : '';
      // Klarna 3x : montant recalculé sur la variante sélectionnée
      var kl = $('#kl3x'), klRb = $('#kl3xRb');
      if (kl) kl.textContent = fmt(Math.round(p / 3));
      if (klRb) klRb.textContent = fmt(Math.round(p / 3));
      var stq = $('#pwStockQty');
      if (stq && el.dataset.qty !== undefined) {
        var q = Number(el.dataset.qty);
        if (q > 0 && q <= 40) { stq.className = 'badge badge--clay'; stq.innerHTML = '<span class="dot"></span>Plus que ' + q + ' en stock'; }
        else { stq.className = 'badge badge--success'; stq.innerHTML = '<span class="dot"></span>En stock'; }
      }
    }
    $$('.bundle', list).forEach(function (el) {
      el.addEventListener('click', function () { apply(el); });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); apply(el); }
      });
    });
    var sel = $('.bundle.active', list) || $('.bundle', list);
    if (sel) apply(sel);
  }

  function stickyAtc() {
    var bar = $('#atcSticky'), anchor = $('#atcBtn');
    if (!bar || !anchor) return;
    var sticky = $('#atcStickyBtn'), form = $('#pwAtcForm');
    sticky && sticky.addEventListener('click', function () { form && form.requestSubmit ? form.requestSubmit() : (form && form.submit()); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { bar.classList.toggle('show', !e[0].isIntersecting); }, { threshold: 0 });
      io.observe(anchor);
    }
  }

  function deliveryCountdown() {
    var els = $$('[data-delivery]'); if (!els.length) return;
    var MOIS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
    var JOURS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
    var fmtD = function (d) { return JOURS[d.getDay()] + ' ' + d.getDate() + ' ' + MOIS[d.getMonth()]; };
    var addBiz = function (from, n) { var d = new Date(from); var a = 0; while (a < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) a++; } return d; };
    function tick() {
      var now = new Date();
      var cutoff = new Date(now); cutoff.setHours(18, 0, 0, 0);
      var shipsToday = now < cutoff && now.getDay() !== 0 && now.getDay() !== 6;
      var base = shipsToday ? now : addBiz(now, 1);
      var d1 = addBiz(base, 1), d2 = addBiz(base, 3);
      els.forEach(function (el) {
        var head = el.querySelector('.dl-head');
        if (head) head.innerHTML = shipsToday ? 'Commande dans les <b class="cd">…</b>, <b>expédié aujourd\'hui</b>' : '<b>Expédié dès le prochain jour ouvré</b>';
        var cd = el.querySelector('.cd');
        if (shipsToday && cd) { var ms = cutoff - now, h = Math.floor(ms / 3.6e6), m = Math.floor((ms % 3.6e6) / 6e4); cd.textContent = h > 0 ? h + 'h ' + String(m).padStart(2, '0') + 'min' : m + 'min'; }
        var eta = el.querySelector('.dl-eta');
        if (eta) eta.innerHTML = 'Livraison estimée entre le <b>' + fmtD(d1) + '</b> et le <b>' + fmtD(d2) + '</b>';
      });
    }
    tick(); setInterval(tick, 60000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    $$('.pw-store [data-ic]').forEach(function (el) { el.innerHTML = I[el.dataset.ic] || ''; });
    reveal(); gallery(); offers(); stickyAtc(); deliveryCountdown(); fbt(); repeatBuy();
  });

  function fbt() {
    var root = document.getElementById('fbt'); if (!root) return;
    var btn = document.getElementById('fbtAdd'); if (!btn) return;
    btn.addEventListener('click', function () {
      var items = [root.dataset.main, root.dataset.acc1, root.dataset.acc2].filter(Boolean).map(function (id) { return { id: Number(id), quantity: 1 }; });
      btn.disabled = true; btn.textContent = 'Ajout…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; btn.textContent = 'Ajouter les 3 au panier'; });
    });
  }

  function repeatBuy() {
    var opts = $$('.repeatbuy__opt'); if (!opts.length) return;
    var now = document.getElementById('rbNow');
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        opts.forEach(function (x) { x.classList.remove('on'); });
        o.classList.add('on');
        if (now) now.textContent = fmt(Number(o.dataset.rbPrice));
        var klRb = document.getElementById('kl3xRb');
        if (klRb) klRb.textContent = fmt(Math.round(Number(o.dataset.rbPrice) / 3));
        // synchronise la buy box du haut
        var top = document.querySelector('.bundle[data-vid="' + o.dataset.rbVid + '"]');
        if (top) top.click();
      });
    });
  }
})();
